import React from "react";
import { Row, Col, Icon } from "../../Component";

/**
 * @param {Object} props
 * @param {Object} props.stats
 * @param {(key: string) => void} [props.onCardNavigate] — total | pending | active | clinicsPending
 */
const PartnerStatsCards = ({ stats, onCardNavigate }) => {
  const {
    total = 0,
    pending = 0,
    active = 0,
    clinicsPending = 0,
    tcPending = 0,
    mtEnabled = 0,
  } = stats || {};

  const cards = [
    {
      key: "total",
      icon: "users",
      label: "Total partners",
      hint: "Draft/pending partners can still set up TC, MT, and clinics in admin. Public visibility follows Live status (enforce on API/site).",
      value: total,
      color: "primary",
      bgClass: "bg-primary-dim",
    },
    {
      key: "pending",
      icon: "clock",
      label: "Pending approval",
      hint: "Awaiting verification to go Live. Setup (TC/MT, dossier) can continue before then.",
      value: pending,
      color: "warning",
      bgClass: "bg-warning-dim",
      highlight: pending > 0,
    },
    {
      key: "active",
      icon: "check-circle",
      label: "Live",
      hint: "Verified / live in workflow — usual gate for public listing. TC and MT remain separate product switches.",
      value: active,
      color: "success",
      bgClass: "bg-success-dim",
    },
    {
      key: "clinicsPending",
      icon: "hospital",
      label: "Clinics pending review",
      hint: "Clinic files awaiting approval (all partners). Opens Clinics with status filter Pending.",
      value: clinicsPending,
      color: "info",
      bgClass: "bg-info-dim",
      highlight: clinicsPending > 0,
    },
  ];

  const footerLine =
    tcPending >= 0 && mtEnabled >= 0
      ? `TC platform pending: ${tcPending} · MT program on: ${mtEnabled} · setup allowed before Live`
      : null;

  return (
    <div className="mb-3">
      <Row>
        {cards.map((stat) => {
          const clickable = typeof onCardNavigate === "function";
          const Inner = (
            <>
              <div className="d-flex align-items-center justify-content-between mb-2">
                <div
                  className="rounded-circle d-flex align-items-center justify-content-center"
                  style={{
                    width: "40px",
                    height: "40px",
                    background: `var(--${stat.color})`,
                    color: "white",
                  }}
                >
                  <Icon name={stat.icon} size="20px" />
                </div>
                {stat.highlight ? (
                  <span className={`badge badge-dim badge-${stat.color}`} style={{ fontSize: "10px" }}>
                    Action
                  </span>
                ) : null}
              </div>
              <div className="stat-value" style={{ fontSize: "22px", fontWeight: "700" }}>
                {stat.value.toLocaleString()}
              </div>
              <div className="stat-label text-soft" style={{ fontSize: "12px", fontWeight: "500" }}>
                {stat.label}
              </div>
              {stat.hint ? (
                <p className="text-soft small mb-0 mt-2" style={{ fontSize: "11px", lineHeight: 1.35 }}>
                  {stat.hint}
                </p>
              ) : null}
              {clickable ? (
                <span className="sr-only">Press to filter list or open related screen</span>
              ) : null}
            </>
          );

          return (
            <Col md="6" lg="3" key={stat.key} className="mb-3">
              {clickable ? (
                <button
                  type="button"
                  className={`card card-stretch text-start w-100 border-0 ${stat.bgClass} partner-stats-card-btn`}
                  style={{
                    borderRadius: "8px",
                    border: stat.highlight ? `2px solid var(--${stat.color})` : "none",
                    cursor: "pointer",
                  }}
                  title={stat.hint}
                  onClick={() => onCardNavigate(stat.key)}
                >
                  <div className="card-inner py-3 px-3">{Inner}</div>
                </button>
              ) : (
                <div
                  className={`card card-stretch ${stat.bgClass}`}
                  style={{
                    borderRadius: "8px",
                    border: stat.highlight ? `2px solid var(--${stat.color})` : "none",
                  }}
                >
                  <div className="card-inner py-3 px-3">{Inner}</div>
                </div>
              )}
            </Col>
          );
        })}
      </Row>
      {footerLine ? (
        <p className="text-soft small mb-0" style={{ fontSize: "12px" }}>
          {footerLine}
        </p>
      ) : null}
    </div>
  );
};

export default PartnerStatsCards;
